import script from "./DashboardHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardHeader.vue?vue&type=style&index=0&id=ecc74858&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecc74858"]])

export default __exports__